import { QuestionSchema } from "@/features/blueprint/schema/questions/QuestionSchema";

export function getQuestionSchema(t: Translator): QuestionSchema[] {
    return [
        {
            id: "project-foundation",
            title: t("schema.projectFoundation.title"),
            questions: [
                {
                    id: "foundation_domain",
                    type: "text",
                    props: { placeholder: t("schema.projectFoundation.questions.foundationDomain.placeholder") },
                    points: 4,
                    label: t("schema.projectFoundation.questions.foundationDomain.label"),
                    help: t("schema.projectFoundation.questions.foundationDomain.help"),
                    summary: { label: t("schema.projectFoundation.questions.foundationDomain.summaryLabel") },
                },
                {
                    id: "foundation_goals",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.projectFoundation.questions.foundationGoals.options.leadCapture"), value: "Lead capture" },
                            { label: t("schema.projectFoundation.questions.foundationGoals.options.ecom"), value: "E-commerce" },
                            { label: t("schema.projectFoundation.questions.foundationGoals.options.portfolio"), value: "Portfolio" },
                            { label: t("schema.projectFoundation.questions.foundationGoals.options.blog"), value: "Blog" },
                            { label: t("schema.projectFoundation.questions.foundationGoals.options.other"), value: "Other" },
                            { label: t("schema.projectFoundation.questions.foundationGoals.options.notSure"), value: "Not so sure" },
                        ],
                    },
                    points: 5,
                    label: t("schema.projectFoundation.questions.foundationGoals.label"),
                    help: t("schema.projectFoundation.questions.foundationGoals.help"),
                    summary: { label: t("schema.projectFoundation.questions.foundationGoals.summaryLabel") },
                },
                {
                    id: "foundation_launchTimeline",
                    type: "select",
                    props: {
                        options: [
                            { label: t("schema.projectFoundation.questions.foundationLaunchTimeline.options.undecided"), value: "Undecided" },
                            { label: t("schema.projectFoundation.questions.foundationLaunchTimeline.options.immediate"), value: "Within 2 weeks" },
                            { label: t("schema.projectFoundation.questions.foundationLaunchTimeline.options.month"), value: "1 month" },
                            { label: t("schema.projectFoundation.questions.foundationLaunchTimeline.options.quarter"), value: "2–3 months" },
                        ],
                    },
                    points: 4,
                    label: t("schema.projectFoundation.questions.foundationLaunchTimeline.label"),
                    help: t("schema.projectFoundation.questions.foundationLaunchTimeline.help"),
                    summary: { label: t("schema.projectFoundation.questions.foundationLaunchTimeline.summaryLabel") },
                },
                {
                    id: "foundation_neededPages",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.contactForm"), value: "Contact Form" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.ecommerceCart"), value: "E-commerce Cart" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.blog"), value: "Blog" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.faqSection"), value: "FAQ Section" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.portfolioGallery"), value: "Portfolio Gallery" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.bookingSystem"), value: "Booking System" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.userLogin"), value: "User Login" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.chatbotSupport"), value: "Chatbot Support" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.newsletterSignup"), value: "Newsletter Signup" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.eventsCalendar"), value: "Events Calendar" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.multiLanguageSupport"), value: "Multi-language Support" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.analyticsDashboard"), value: "Analytics Dashboard" },
                            { label: t("schema.projectFoundation.questions.foundationNeededPages.options.notSure"), value: "Not sure" }
                        ],
                    },
                    points: 4,
                    label: t("schema.projectFoundation.questions.foundationNeededPages.label"),
                    help: t("schema.projectFoundation.questions.foundationNeededPages.help"),
                    summary: { label: t("schema.projectFoundation.questions.foundationNeededPages.summaryLabel") },
                },

            ],
        },
        {
            id: "story-credibility",
            title: t("schema.storyCredibility.title"),
            questions: [
                {
                    id: "credibility_oneLiner",
                    type: "text",
                    props: { placeholder: t("schema.storyCredibility.questions.credibilityOneLiner.placeholder") },
                    points: 4,
                    label: t("schema.storyCredibility.questions.credibilityOneLiner.label"),
                    help: t("schema.storyCredibility.questions.credibilityOneLiner.help"),
                    summary: { label: t("schema.storyCredibility.questions.credibilityOneLiner.summaryLabel") },
                },
                {
                    id: "credibility_mission",
                    type: "textarea",
                    props: { rows: 5, placeholder: t("schema.storyCredibility.questions.credibilityMission.placeholder") },
                    points: 5,
                    label: t("schema.storyCredibility.questions.credibilityMission.label"),
                    help: t("schema.storyCredibility.questions.credibilityMission.help"),
                    summary: { label: t("schema.storyCredibility.questions.credibilityMission.summaryLabel") },
                },
                {
                    id: "credibility_trustSignals",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.storyCredibility.questions.credibilityTrustSignals.options.testimonials"), value: "Customer testimonials" },
                            { label: t("schema.storyCredibility.questions.credibilityTrustSignals.options.certifications"), value: "Certifications" },
                            { label: t("schema.storyCredibility.questions.credibilityTrustSignals.options.awards"), value: "Awards" },
                            { label: t("schema.storyCredibility.questions.credibilityTrustSignals.options.press"), value: "Press mentions" },
                            { label: t("schema.storyCredibility.questions.credibilityTrustSignals.options.logos"), value: "Client logos" },
                            { label: t("schema.storyCredibility.questions.credibilityTrustSignals.options.dontHaveAny"), value: "Don't have any at the moment" },
                        ],
                    },
                    points: 5,
                    label: t("schema.storyCredibility.questions.credibilityTrustSignals.label"),
                    help: t("schema.storyCredibility.questions.credibilityTrustSignals.help"),
                    summary: { label: t("schema.storyCredibility.questions.credibilityTrustSignals.summaryLabel") },
                },
                {
                    id: "credibility_assets",
                    type: "file",
                    props: {},
                    points: 5,
                    label: t("schema.storyCredibility.questions.credibilityAssets.label"),
                    help: t("schema.storyCredibility.questions.credibilityAssets.help"),
                    summary: { label: t("schema.storyCredibility.questions.credibilityAssets.summaryLabel") },
                },
                {
                    id: "credibility_toneGrid",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.storyCredibility.questions.credibilityToneGrid.options.professional"), value: "Professional" },
                            { label: t("schema.storyCredibility.questions.credibilityToneGrid.options.playful"), value: "Playful" },
                            { label: t("schema.storyCredibility.questions.credibilityToneGrid.options.luxury"), value: "Luxury" },
                            { label: t("schema.storyCredibility.questions.credibilityToneGrid.options.friendly"), value: "Friendly" },
                            { label: t("schema.storyCredibility.questions.credibilityToneGrid.options.innovative"), value: "Innovative" },
                            { label: t("schema.storyCredibility.questions.credibilityToneGrid.options.notSure"), value: "I'm not sure about this" },
                        ],
                    },
                    points: 4,
                    label: t("schema.storyCredibility.questions.credibilityToneGrid.label"),
                    help: t("schema.storyCredibility.questions.credibilityToneGrid.help"),
                    summary: { label: t("schema.storyCredibility.questions.credibilityToneGrid.summaryLabel") },
                },
            ],
        },
        {
            id: "design-branding",
            title: t("schema.designBranding.title"),
            questions: [
                {
                    id: "branding_primaryColor",
                    type: "colorpicker",
                    props: {},
                    points: 2,
                    label: t("schema.designBranding.questions.brandingPrimaryColor.label"),
                    help: t("schema.designBranding.questions.brandingPrimaryColor.help"),
                    summary: { label: t("schema.designBranding.questions.brandingPrimaryColor.summaryLabel") },
                },
                {
                    id: "branding_palette",
                    type: "palette",
                    props: {},
                    points: 2,
                    label: t("schema.designBranding.questions.brandingPalette.label"),
                    help: t("schema.designBranding.questions.brandingPalette.help"),
                    summary: { label: t("schema.designBranding.questions.brandingPalette.summaryLabel") },
                },
                {
                    id: "branding_font",
                    type: "font",
                    props: {},
                    points: 2,
                    label: t("schema.designBranding.questions.brandingFont.label"),
                    help: t("schema.designBranding.questions.brandingFont.help"),
                    summary: { label: t("schema.designBranding.questions.brandingFont.summaryLabel") },
                },
                {
                    id: "branding_styles",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.designBranding.questions.brandingStyles.options.minimalist"), value: "Minimalist" },
                            { label: t("schema.designBranding.questions.brandingStyles.options.illustrative"), value: "Illustrative" },
                            { label: t("schema.designBranding.questions.brandingStyles.options.photography"), value: "Photography-heavy" },
                            { label: t("schema.designBranding.questions.brandingStyles.options.boldTypography"), value: "Bold typography" },
                            { label: t("schema.designBranding.questions.brandingStyles.options.darkMode"), value: "Dark mode" },
                        ],
                    },
                    points: 4,
                    label: t("schema.designBranding.questions.brandingStyles.label"),
                    help: t("schema.designBranding.questions.brandingStyles.help"),
                    summary: { label: t("schema.designBranding.questions.brandingStyles.summaryLabel") },
                },
                {
                    id: "branding_logoUpload",
                    type: "file",
                    props: {},
                    points: 5,
                    label: t("schema.designBranding.questions.brandingLogoUpload.label"),
                    help: t("schema.designBranding.questions.brandingLogoUpload.help"),
                    summary: { label: t("schema.designBranding.questions.brandingLogoUpload.summaryLabel") },
                },
            ],
        },
        {
            id: "content-structure",
            title: t("schema.contentStructure.title"),
            questions: [
                {
                    id: "content_corePages",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.contentStructure.questions.contentCorePages.options.home"), value: "Home" },
                            { label: t("schema.contentStructure.questions.contentCorePages.options.about"), value: "About" },
                            { label: t("schema.contentStructure.questions.contentCorePages.options.services"), value: "Services" },
                            { label: t("schema.contentStructure.questions.contentCorePages.options.contact"), value: "Contact" },
                            { label: t("schema.contentStructure.questions.contentCorePages.options.blog"), value: "Blog" },
                            { label: t("schema.contentStructure.questions.contentCorePages.options.faq"), value: "FAQ" },
                        ],
                    },
                    points: 5,
                    label: t("schema.contentStructure.questions.contentCorePages.label"),
                    help: t("schema.contentStructure.questions.contentCorePages.help"),
                    summary: { label: t("schema.contentStructure.questions.contentCorePages.summaryLabel") },
                },
                {
                    id: "content_keywords",
                    type: "listinput",
                    props: { placeholder: t("schema.contentStructure.questions.contentKeywords.placeholder") },
                    points: 6,
                    label: t("schema.contentStructure.questions.contentKeywords.label"),
                    help: t("schema.contentStructure.questions.contentKeywords.help"),
                    summary: { label: t("schema.contentStructure.questions.contentKeywords.summaryLabel") },
                },
                {
                    id: "content-writing-style",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.contentStructure.questions.contentWritingStyle.options.concise"), value: "concise" },
                            { label: t("schema.contentStructure.questions.contentWritingStyle.options.narrative"), value: "narrative" },
                            { label: t("schema.contentStructure.questions.contentWritingStyle.options.analytical"), value: "analytical" },
                            { label: t("schema.contentStructure.questions.contentWritingStyle.options.conversational"), value: "conversational" },
                            { label: t("schema.contentStructure.questions.contentWritingStyle.options.visual"), value: "visual" },
                            { label: t("schema.contentStructure.questions.contentWritingStyle.options.seo"), value: "seo" },
                            { label: t("schema.contentStructure.questions.contentWritingStyle.options.unsure"), value: "unsure" },
                        ],
                    },
                    points: 5,
                    label: t("schema.contentStructure.questions.contentWritingStyle.label"),
                    help: t("schema.contentStructure.questions.contentWritingStyle.help"),
                    summary: { label: t("schema.contentStructure.questions.contentWritingStyle.summaryLabel") },
                },
                {
                    id: "content_blogNeeds",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.contentStructure.questions.contentBlogChoices.options.articles"), value: "articles" },
                            { label: t("schema.contentStructure.questions.contentBlogChoices.options.news"), value: "news" },
                            { label: t("schema.contentStructure.questions.contentBlogChoices.options.caseStudies"), value: "caseStudies" },
                            { label: t("schema.contentStructure.questions.contentBlogChoices.options.quickGuides"), value: "quickGuides" },
                            { label: t("schema.contentStructure.questions.contentBlogChoices.options.undecided"), value: "undecided" },
                        ],
                        ariaLabel: t("schema.contentStructure.questions.contentBlogChoices.ariaLabel"),
                    },
                    points: 4,
                    label: t("schema.contentStructure.questions.contentBlogChoices.label"),
                    help: t("schema.contentStructure.questions.contentBlogChoices.help"),
                    summary: { label: t("schema.contentStructure.questions.contentBlogChoices.summaryLabel") },
                }
            ],
        },
        {
            id: "integrations-marketing",
            title: t("schema.integrationsMarketing.title"),
            questions: [
                {
                    id: "marketing_existingTools",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.integrationsMarketing.questions.marketingExistingTools.options.mailchimp"), value: "Mailchimp" },
                            { label: t("schema.integrationsMarketing.questions.marketingExistingTools.options.hubspot"), value: "HubSpot" },
                            { label: t("schema.integrationsMarketing.questions.marketingExistingTools.options.ga"), value: "Google Analytics" },
                            { label: t("schema.integrationsMarketing.questions.marketingExistingTools.options.zapier"), value: "Zapier" },
                            { label: t("schema.integrationsMarketing.questions.marketingExistingTools.options.stripe"), value: "Stripe" },
                            { label: t("schema.integrationsMarketing.questions.marketingExistingTools.options.none"), value: "None" },
                            { label: t("schema.integrationsMarketing.questions.marketingExistingTools.options.dontNeed"), value: "Dont need this now" },
                        ],
                    },
                    points: 5,
                    label: t("schema.integrationsMarketing.questions.marketingExistingTools.label"),
                    help: t("schema.integrationsMarketing.questions.marketingExistingTools.help"),
                    summary: { label: t("schema.integrationsMarketing.questions.marketingExistingTools.summaryLabel") },
                },
                {
                    id: "marketing_social",
                    type: "select",
                    props: {
                        options: [
                            { label: t("schema.integrationsMarketing.questions.marketingSocial.options.facebook"), value: "Facebook" },
                            { label: t("schema.integrationsMarketing.questions.marketingSocial.options.instagram"), value: "Instagram" },
                            { label: t("schema.integrationsMarketing.questions.marketingSocial.options.linkedin"), value: "LinkedIn" },
                            { label: t("schema.integrationsMarketing.questions.marketingSocial.options.twitter"), value: "Twitter" },
                            { label: t("schema.integrationsMarketing.questions.marketingSocial.options.tiktok"), value: "TikTok" },
                            { label: t("schema.integrationsMarketing.questions.marketingSocial.options.other"), value: "Other" },
                            { label: t("schema.integrationsMarketing.questions.marketingSocial.options.dontHave"), value: "I don't have this" },
                        ],
                    },
                    points: 4,
                    label: t("schema.integrationsMarketing.questions.marketingSocial.label"),
                    help: t("schema.integrationsMarketing.questions.marketingSocial.help"),
                    summary: { label: t("schema.integrationsMarketing.questions.marketingSocial.summaryLabel") },
                },
                {
                    id: "marketing_funnel",
                    type: "textarea",
                    props: { rows: 4, placeholder: t("schema.integrationsMarketing.questions.marketingFunnel.placeholder") },
                    points: 6,
                    label: t("schema.integrationsMarketing.questions.marketingFunnel.label"),
                    help: t("schema.integrationsMarketing.questions.marketingFunnel.help"),
                    summary: { label: t("schema.integrationsMarketing.questions.marketingFunnel.summaryLabel") },
                },
                {
                    id: "marketing_apiGrid",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.integrationsMarketing.questions.marketingApiGrid.options.crm"), value: "CRM" },
                            { label: t("schema.integrationsMarketing.questions.marketingApiGrid.options.payment"), value: "Payment Gateway" },
                            { label: t("schema.integrationsMarketing.questions.marketingApiGrid.options.analytics"), value: "Analytics" },
                            { label: t("schema.integrationsMarketing.questions.marketingApiGrid.options.automation"), value: "Marketing Automation" },
                            { label: t("schema.integrationsMarketing.questions.marketingApiGrid.options.custom"), value: "Custom API" },
                            { label: t("schema.integrationsMarketing.questions.marketingApiGrid.options.dontNeed"), value: "Dont need this now" },
                        ],
                    },
                    points: 5,
                    label: t("schema.integrationsMarketing.questions.marketingApiGrid.label"),
                    help: t("schema.integrationsMarketing.questions.marketingApiGrid.help"),
                    summary: { label: t("schema.integrationsMarketing.questions.marketingApiGrid.summaryLabel") },
                },
                {
                    id: "marketing_growthTactics",
                    type: "multiselect",
                    props: {
                        options: [
                            { label: t("schema.integrationsMarketing.questions.marketingGrowthTactics.options.seo"), value: "SEO" },
                            { label: t("schema.integrationsMarketing.questions.marketingGrowthTactics.options.ppc"), value: "PPC Ads" },
                            { label: t("schema.integrationsMarketing.questions.marketingGrowthTactics.options.email"), value: "Email Campaigns" },
                            { label: t("schema.integrationsMarketing.questions.marketingGrowthTactics.options.referral"), value: "Referral Program" },
                            { label: t("schema.integrationsMarketing.questions.marketingGrowthTactics.options.abTesting"), value: "A/B Testing" },
                            { label: t("schema.integrationsMarketing.questions.marketingGrowthTactics.options.dontNeed"), value: "Dont need this now" },
                        ],
                    },
                    points: 5,
                    label: t("schema.integrationsMarketing.questions.marketingGrowthTactics.label"),
                    help: t("schema.integrationsMarketing.questions.marketingGrowthTactics.help"),
                    summary: { label: t("schema.integrationsMarketing.questions.marketingGrowthTactics.summaryLabel") },
                },
            ],
        },
    ];
}